import Vue from "Vue";
import Vuex from "vuex";
import userapi from "@/api/user/index.js";
import api from "@/api/course/index.js";

Vue.use(Vuex);

const store = new Vuex.Store({
  state: {
    userinfo: '',
    pageSetting: {},
    tenantId: 312,
    HeaderFooter: {},
    headerList: [],
    headerLogo: '',
    footerLogo: ''
  },
  mutations: {
    SET_USER_INFO(state, userinfo) {
      state.userinfo = userinfo;
    },
    SET_TENANT_ID(state,id){
      state.tenantId = id;
    },
    SET_CONFIG_SETTING(state, pageSetting){
      state.pageSetting = pageSetting;
    },
    SET_HEADER_FOOTER(state, HeaderFooter) {
      state.headerList = HeaderFooter.nav;
      state.HeaderFooter = Object.assign({}, state.HeaderFooter, HeaderFooter);
      // state.headerLogo = HeaderFooter.logo;
    }
  },
  getters:{
    tenantId: state => {
      return state.tenantId
    },
  },
  actions: {
    setConfigSetting({commit}, pageSetting){
      commit("SET_CONFIG_SETTING", pageSetting);
    },
    setUserInfo({
      commit
    }, userinfo) {
      commit("SET_USER_INFO", userinfo);
    },
   setTenantId({commit
    }){
      return new Promise(function(resolve,reject){
        // 获取子域名
        let predomain = window.document.domain.split(".")[0];
        // 获取租户id
        userapi.getTenantId(predomain).then(res =>{
          let tenantId = res.params.id;
          commit("SET_TENANT_ID",tenantId);
          resolve()
        }).catch(err=>{
          reject(err)
        })
      });

    },
    async setHeaderFooter({commit}) {
      await api.getHeaderFooter({
        tenant_id: this.getters.tenantId,
      }).then(res => {
        if(res.data.code == 200) {
          commit("SET_HEADER_FOOTER", res.data.data);
        }
      }).catch(err => console.log(err));
    },
  }
});

export default store



// WEBPACK FOOTER //
// ./src/store/index.js